var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v(" Step 1 of 9: Client Information "),
        ]),
        _c(
          "div",
          { staticClass: "grid grid-cols-2 gap-3" },
          [
            _c("ValidationProvider", {
              attrs: { name: "Client Name", rules: "required_field" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mb-2" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Client Name "),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "client_name",
                              placeholder: "Enter full name",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) =>
                                _vm.updateField("client_name", val),
                            },
                            model: {
                              value: _vm.localFormData.client_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "client_name", $$v)
                              },
                              expression: "localFormData.client_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "ValidationProvider",
              { attrs: { name: "Client ID" } },
              [
                _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Client ID "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "client_id",
                        placeholder: "Enter Client ID",
                        inputClass: "w-full",
                      },
                      on: { input: (val) => _vm.updateField("client_id", val) },
                      model: {
                        value: _vm.localFormData.client_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "client_id", $$v)
                        },
                        expression: "localFormData.client_id",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Date of Birth" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Date of Birth "),
                              _c("span", { staticClass: "subText" }, [
                                _vm._v("(optional)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormDatepicker", {
                      attrs: {
                        name: "dob",
                        placeholder: "Select date of birth",
                        inputClass: "w-full",
                      },
                      on: { input: (val) => _vm.updateField("dob", val) },
                      model: {
                        value: _vm.localFormData.dob,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "dob", $$v)
                        },
                        expression: "localFormData.dob",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Gender" } },
              [
                _c(
                  "FormGroup",
                  { attrs: { title: "Gender" } },
                  [
                    _c("FormSelect", {
                      attrs: {
                        name: "gender",
                        placeholder: "Select gender",
                        options: [
                          { label: "Male", value: "male" },
                          { label: "Female", value: "female" },
                          { label: "Other", value: "other" },
                        ],
                        getParentCustom: "clientWidth",
                      },
                      on: { input: (val) => _vm.updateField("gender", val) },
                      model: {
                        value: _vm.localFormData.gender,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "gender", $$v)
                        },
                        expression: "localFormData.gender",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-span-2" },
              [
                _c("LocationModal", {
                  attrs: {
                    location: _vm.localFormData.address,
                    isClient: true,
                  },
                  on: {
                    locationAdded: (val) =>
                      _vm.updateField("address", val.description),
                  },
                }),
              ],
              1
            ),
            _c("ValidationProvider", {
              attrs: { rules: "required_field", name: "Phone Number" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mb-2" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Phone Number "),
                                      _c(
                                        "span",
                                        { staticClass: "text-sub-heading" },
                                        [_vm._v("(Admin view only)")]
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "phone",
                              placeholder: "Enter phone number",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) => _vm.updateField("phone", val),
                            },
                            model: {
                              value: _vm.localFormData.phone_number,
                              callback: function ($$v) {
                                _vm.$set(_vm.localFormData, "phone_number", $$v)
                              },
                              expression: "localFormData.phone_number",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ValidationProvider", {
              attrs: { rules: "required_field", name: "Email Address" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ errors }) {
                    return [
                      _c(
                        "FormGroup",
                        {
                          attrs: { errors: errors },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c("p", { staticClass: "mb-2" }, [
                                      _c(
                                        "span",
                                        { staticClass: "required-icon" },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(" Email Address "),
                                      _c(
                                        "span",
                                        { staticClass: "text-sub-heading" },
                                        [_vm._v("(Admin view only)")]
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("FormInputGroup", {
                            attrs: {
                              name: "email",
                              placeholder: "Enter email address",
                              inputClass: "w-full",
                            },
                            on: {
                              input: (val) => _vm.updateField("email", val),
                            },
                            model: {
                              value: _vm.localFormData.email_address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localFormData,
                                  "email_address",
                                  $$v
                                )
                              },
                              expression: "localFormData.email_address",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "ValidationProvider",
              {
                ref: "startDateValidator",
                attrs: { name: "Care Plan Start Date", vid: "start_date" },
              },
              [
                _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Care Plan Start Date "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormDatepicker", {
                      attrs: {
                        isCalenderIcon: true,
                        name: "care_plan_start_date",
                        placeholder: "Select",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) =>
                          _vm.updateField("care_plan_start_date", val),
                      },
                      model: {
                        value: _vm.localFormData.care_plan_start_date,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localFormData,
                            "care_plan_start_date",
                            $$v
                          )
                        },
                        expression: "localFormData.care_plan_start_date",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              {
                ref: "endDateValidator",
                attrs: { name: "Care Plan End Date", vid: "end_date" },
              },
              [
                _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Care Plan End Date "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormDatepicker", {
                      attrs: {
                        name: "care_plan_end_date",
                        placeholder: "Select",
                        isCalenderIcon: true,
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) =>
                          _vm.updateField("care_plan_end_date", val),
                      },
                      model: {
                        value: _vm.localFormData.care_plan_end_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "care_plan_end_date", $$v)
                        },
                        expression: "localFormData.care_plan_end_date",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Care Plan Created By" } },
              [
                _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Care Plan Created By "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "created_by",
                        placeholder: "Enter",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => _vm.updateField("created_by", val),
                      },
                      model: {
                        value: _vm.localFormData.care_plan_created_by,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localFormData,
                            "care_plan_created_by",
                            $$v
                          )
                        },
                        expression: "localFormData.care_plan_created_by",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Care Plan Created Date" } },
              [
                _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Care Plan Created Date "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormDatepicker", {
                      attrs: {
                        name: "created_at",
                        placeholder: "Select",
                        isCalenderIcon: true,
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => _vm.updateField("created_at", val),
                      },
                      model: {
                        value: _vm.localFormData.care_plan_created_at,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localFormData,
                            "care_plan_created_at",
                            $$v
                          )
                        },
                        expression: "localFormData.care_plan_created_at",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Last Updated By" } },
              [
                _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Last Updated By "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormInputGroup", {
                      attrs: {
                        name: "updated_by",
                        placeholder: "Enter",
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => _vm.updateField("updated_by", val),
                      },
                      model: {
                        value: _vm.localFormData.care_plan_updated_by,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localFormData,
                            "care_plan_updated_by",
                            $$v
                          )
                        },
                        expression: "localFormData.care_plan_updated_by",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "ValidationProvider",
              { attrs: { name: "Last Updated Date" } },
              [
                _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(" Last Updated Date "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("FormDatepicker", {
                      attrs: {
                        name: "updated_at",
                        placeholder: "Select",
                        isCalenderIcon: true,
                        inputClass: "w-full",
                      },
                      on: {
                        input: (val) => _vm.updateField("updated_at", val),
                      },
                      model: {
                        value: _vm.localFormData.care_plan_updated_at,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.localFormData,
                            "care_plan_updated_at",
                            $$v
                          )
                        },
                        expression: "localFormData.care_plan_updated_at",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.localFormData.access_type === "Other"
              ? _c(
                  "div",
                  { staticClass: "col-span-2" },
                  [
                    _c(
                      "FormGroup",
                      {
                        attrs: { title: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _c("p", { staticClass: "mb-2" }, [
                                    _vm._v(" Other"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1645763656
                        ),
                      },
                      [
                        _c("FormInputGroup", {
                          attrs: {
                            name: "access_type_other",
                            placeholder: "Enter",
                            inputClass: "w-full",
                          },
                          on: {
                            input: (val) =>
                              _vm.updateField("access_type_other", val),
                          },
                          model: {
                            value: _vm.localFormData.access_type_other,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.localFormData,
                                "access_type_other",
                                $$v
                              )
                            },
                            expression: "localFormData.access_type_other",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }